var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgNavi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "888px",
    height: "115px",
    viewBox: "0 0 888 115",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 888,
    height: 115
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "72.7442432%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004485",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B7EC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M826.527245,223.478999 C824.991688,226.515454 821.227455,229 818.163026,229 L70.1948668,228.995534 C67.1304379,228.995534 63.3695478,226.509073 61.8373334,223.470066 L9.68298176,120.023234 C8.1507673,116.984227 8.15021013,112.011306 9.6824246,108.972299 L22.5123527,83.5226088 C24.0445672,80.4836017 26.5512701,75.5100429 28.0834845,72.4710358 L61.8373334,5.52100115 C63.3695478,2.48199404 67.1304379,-0.00446631319 70.1948668,-0.00446631319 L818.336305,5.0393717e-16 C821.400734,5.0393717e-16 825.161624,2.48646036 826.693839,5.52546746 L878.852648,108.976766 C880.384862,112.015773 880.382076,116.986779 878.846519,120.023234 L826.527245,223.478999 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.8%",
    y: "-6.1%",
    width: "103.7%",
    height: "114.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page01-teileidentifikation1",
    transform: "translate(-507.000000, -973.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background-nav",
    transform: "translate(507.000000, 973.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "background",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-3)",
    strokeWidth: 4,
    d: "M70.1948548,1.99553369 L818.336305,2 C819.520794,2 820.823352,2.52235587 821.986648,3.29145293 C823.206879,4.09819194 824.289365,5.19889482 824.907985,6.42587167 L877.066791,109.877163 C878.348916,112.420142 878.346693,116.579799 877.061764,119.120655 L824.742484,222.576432 C824.122373,223.802656 823.038278,224.902671 821.816762,225.708961 C820.651937,226.477832 819.348069,227 818.163038,227 L70.1948668,226.995534 C69.0103783,226.995534 67.7078201,226.473178 66.5445241,225.704081 C65.3242928,224.897342 64.2418071,223.796639 63.623202,222.569692 L11.4688384,119.122837 C10.1863109,116.579061 10.1857411,112.416498 11.4683196,109.872621 L24.2982664,84.4228934 L27.0838323,78.8971069 L29.8693539,73.3714083 L63.62319,6.42139895 C64.2418071,5.19442851 65.3242928,4.09372563 66.5445241,3.28698661 C67.7078201,2.51788956 69.0103783,1.99553369 70.1948548,1.99553369 Z",
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNavi);
export default __webpack_public_path__ + "static/media/bg-navi.6dc49b6db8b33efbc30aec9170c39db8.svg";
export { ForwardRef as ReactComponent };